module.exports = __webpack_public_path__ + "static/img/quickwire_64.698cede.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/quickwire_64.png
// module id = QiZL
// module chunks = 0